enum StaffConfirmationStatus {
  Initialized,
  ProfileVerification,
  AgreementSigning,
  AgreementVerification,
  ProfileConfirmed,
  ProfileRejected,
}

export default StaffConfirmationStatus
